var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"customToggleSwitcher"},[_c('ui-toggle-switcher',{attrs:{"value":true},on:{"onChange":function($event){return _vm.onChangeBlocked(_vm.data)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }